// Hook for fetching public candidate data

import { useQuery } from '@tanstack/react-query';
import {
  getPublicProfile,
  getPublicExperiences,
  getPublicSkills,
  PublicProfile,
  PublicExperience,
  PublicSkill,
} from '../lib/api';

export function useProfile() {
  return useQuery<PublicProfile>({
    queryKey: ['profile'],
    queryFn: getPublicProfile,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useExperiences() {
  return useQuery<PublicExperience[]>({
    queryKey: ['experiences'],
    queryFn: getPublicExperiences,
    staleTime: 5 * 60 * 1000,
  });
}

export function useSkills() {
  return useQuery<PublicSkill[]>({
    queryKey: ['skills'],
    queryFn: getPublicSkills,
    staleTime: 5 * 60 * 1000,
  });
}

// Combined hook for all candidate data
export function useCandidateData() {
  const profile = useProfile();
  const experiences = useExperiences();
  const skills = useSkills();

  return {
    profile: profile.data,
    experiences: experiences.data,
    skills: skills.data,
    isLoading: profile.isLoading || experiences.isLoading || skills.isLoading,
    error: profile.error || experiences.error || skills.error,
  };
}
